import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { EDITCOWORKER_RESPONSE } from "../../constants/action_types";

const isValidURL = (string) => {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
};
export function UserAvatar({ className, user }) {
  const coworkerUpdated = useSelector(
    (state) => state.coworker.update_response
  );

  // const userRef = useRef(user);
  const [_user, setUser] = useState(
    user || JSON.parse(localStorage.getItem("user"))
  );

  useEffect(() => {
    if (coworkerUpdated?.type === EDITCOWORKER_RESPONSE) {
      if (!user) {
        setUser(JSON.parse(localStorage.getItem("user")));
      }
    }
  }, [coworkerUpdated]);

  useEffect(() => {
    if (!user) setUser(JSON.parse(localStorage.getItem("user")));
    else setUser(user);
  }, [user]);

  return (
    <div className={className || ""}>
      <button
        type="button"
        className="relative overflow-hidden flex rounded-full bg-white text-sm ring-2 ring-white ring-opacity-20 focus:outline-none focus:ring-opacity-100"
        id="user-menu-button"
        x-ref="button"
      >
        <span className="absolute -inset-1.5"></span>
        <span className="sr-only">Open user menu</span>
        {_user?.profile_pic ? (
          <img
            class="inline-block h-10 w-10 object-cover rounded-full"
            src={
              !isValidURL(_user.profile_pic)
                ? `${process.env.REACT_APP_ATTACHMENT_URL}${_user.profile_pic}`
                : _user.profile_pic
            }
            alt=""
          />
        ) : (
          <svg
            className="h-10 w-10 text-gray-300 inline-block"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
        )}
      </button>
    </div>
  );
}
